export default "__VITE_ASSET__5dba2650__"